import { TapChoice } from './TapChoice';
import { CategorySort } from './CategorySort';
import { WhatDisappeared } from './WhatDisappeared';
import { RememberLocation } from './RememberLocation';
import { FindPair } from './FindPair';
import { PikoBag } from './PikoBag';
import { SequenceTap } from './SequenceTap';
import { PatternChoice } from './PatternChoice';
import { ActionMission } from './ActionMission';
import { LoudSoft } from './LoudSoft';
import { MotionTap } from './MotionTap';
import { DragDrop } from './DragDrop';

const MAP = {
  'tap-choice': TapChoice,
  'drag-drop': DragDrop,
  'sound-match': TapChoice,
  'listen-choose': TapChoice,
  'category-sort': CategorySort,
  'what-disappeared': WhatDisappeared,
  'remember-location': RememberLocation,
  'find-pair': FindPair,
  'piko-bag': PikoBag,
  'sequence-tap': SequenceTap,
  'pattern-choice': PatternChoice,
  'action-mission': ActionMission,
  'loud-soft': LoudSoft,
  'motion-tap': MotionTap,
};

export function ActivityHost({ activity, onComplete }) {
  const Cmp = MAP[activity.type];
  if (!Cmp) return null;
  return <Cmp key={activity.id} activity={activity} onComplete={onComplete} />;
}
